export const LOCALE_PREFIX =
    'components.Dialog.components.GroupMonitoring.components.GroupMonitoringForm.components.SendingFrequencySubComponent'

export const WEEKLY_DEFINITIONS = [
    { value: '0', label: 'monday' },
    { value: '1', label: 'tuesday' },
    { value: '2', label: 'wednesday' },
    { value: '3', label: 'thursday' },
    { value: '4', label: 'friday' },
]
